var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacilityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#5FC884",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6654 11.3333H15.8654C16.6121 11.3333 16.9855 11.3333 17.2707 11.4787C17.5216 11.6065 17.7255 11.8105 17.8534 12.0613C17.9987 12.3466 17.9987 12.7199 17.9987 13.4667V18M12.6654 18V8.13333C12.6654 7.3866 12.6654 7.01323 12.52 6.72801C12.3922 6.47713 12.1882 6.27316 11.9374 6.14532C11.6521 6 11.2788 6 10.532 6H8.13203C7.38529 6 7.01193 6 6.72671 6.14532C6.47583 6.27316 6.27185 6.47713 6.14402 6.72801C5.9987 7.01323 5.9987 7.3866 5.9987 8.13333V18M18.6654 18H5.33203M8.33203 8.66667H10.332M8.33203 11.3333H10.332M8.33203 14H10.332",
    stroke: "#5FC884",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon);
export default __webpack_public_path__ + "static/media/facility_icon.64120d808af6e21a54bfd17318791f1c.svg";
export { ForwardRef as ReactComponent };